// extracted by mini-css-extract-plugin
export default {"container":"FJ-z","topReviewHeading":"GJ-z","criticalReview":"HJ-z","favorableReview":"IJ-z","vsSeparator":"JJ-z"};